/* tslint:disable */

/**
 */
export class ConsumptionResult {
    eqptPerm?: number;
    id?: number;
    tc?: number;
    vc?: number;
    kgProduct?: number;
    product?: number;
    day?: number;
    week?: number;
    hour?: number;
    month?: number;
    year?: number;
    equipName?: string;
    eqptCold?: number;
    lineCold?: number;
    linePerm?: number;
    tank?: number;
    percentProduct?: number;
    percentEquipmentPerm?: number;
    percentEquipmentDown?: number;
    percentLine?: number;
    ENABLE_CONS_PIE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/consumption-result.ts